"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelect = void 0;
var react_1 = require("react");
var debounce_1 = __importDefault(require("../../utility/debounce"));
function isSelectOptionOrGroup(option) {
    return typeof option === "object" && ("value" in option || "heading" in option);
}
exports.useSelect = function (configuration) {
    var _a = react_1.useState(false), isSearching = _a[0], setIsSearching = _a[1];
    var _b = react_1.useState(""), searchQuery = _b[0], setSearchQuery = _b[1];
    var _c = react_1.useState(), searchableInputEl = _c[0], setSearchableInputEl = _c[1];
    var _d = react_1.useState(), highlightedEl = _d[0], setHighlightedEl = _d[1];
    var _e = react_1.useState(true), scrollIntoView = _e[0], setScrollIntoView = _e[1];
    var _f = react_1.useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = react_1.useState(), highlightedOption = _g[0], setHighlightedOption = _g[1];
    var builtInitialOptions = react_1.useMemo(function () {
        if (!configuration.initialOptions) {
            return [];
        }
        var outputOptions = [];
        configuration.initialOptions.forEach(function (initialOption) {
            if (isSelectOptionOrGroup(initialOption)) {
                outputOptions.push(initialOption);
            }
            else {
                outputOptions.push({ value: initialOption });
            }
        });
        return outputOptions;
    }, [configuration.initialOptions]);
    var _h = react_1.useState(builtInitialOptions), options = _h[0], setOptions = _h[1];
    // Handle invalidation of the available options.
    //
    // Internally we track the available options for the select. If our
    // parent component should change and pass new `initialOptions` we
    // need to invalidate this.
    //
    // For selects set to fetch options dynamically, they may also depend
    // on other values hosted in the parent and so we also can pass a
    // list of other dependencies using `optionsDependOn`.
    // Track first run using a ref
    var isFirstRun = react_1.useRef(true);
    // Build our list of dependencies for our useEffect.
    var resetOptionDependencies = [configuration.initialOptions];
    // If additional dependencies have been passed, let's add them to our list
    if (configuration.optionsDependOn) {
        resetOptionDependencies = resetOptionDependencies.concat(configuration.optionsDependOn);
    }
    // Install the affect to clear options state
    react_1.useEffect(function () {
        // No need to do anything on first render - doing so would cause a needless
        // rerender.
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        setOptions(builtInitialOptions);
    }, resetOptionDependencies);
    // Flatten grouped option sets into a simple list.
    var flattenedOptions = react_1.useMemo(function () {
        var flatOptions = [];
        options.forEach(function (option) {
            if ("options" in option) {
                option.options.forEach(function (subOption) { return flatOptions.push(subOption); });
            }
            else {
                flatOptions.push(option);
            }
        });
        return flatOptions;
    }, [options]);
    var _j = react_1.useState([]), selectedOptions = _j[0], setSelectedOptions = _j[1];
    // INITIALISATION
    react_1.useEffect(function () {
        // Use the provided `value` if it's available, otherwise use the `defaultValue`
        var valueToUse = configuration.value || configuration.defaultValue;
        if (valueToUse !== undefined) {
            /**
             * If the default value is an array, then use it as-is, otherwise
             * place the non-array default value in an array.
             */
            var initiallySelected = Array.isArray(valueToUse) ? valueToUse : [valueToUse];
            var initiallySelectedOptions_1 = [];
            var fetchedOptions_1 = [];
            // Map initially selected values to options that may already be supplied.
            initiallySelected.forEach(function (selectedValue) {
                // Finds an option in the initial options array with the same value
                var optionWithValue = flattenedOptions.find(function (option) { return option.value === selectedValue; });
                // If the initially selected value is available, use it
                if (optionWithValue) {
                    initiallySelectedOptions_1.push(optionWithValue);
                }
                else {
                    // If the initially selected value is NOT available, try to get it
                    if (configuration.getItemForValue) {
                        var fetchedItem = configuration.getItemForValue(selectedValue);
                        initiallySelectedOptions_1.push(fetchedItem);
                        fetchedOptions_1.push(fetchedItem);
                    }
                    else {
                        // If all else fails, create an option with the value set as is.
                        // This may not look the best in a real select input, but it's a last resort
                        // to ensure that selected values are shown properly
                        initiallySelectedOptions_1.push({ value: selectedValue });
                    }
                }
            });
            setOptions(__spreadArrays(options, fetchedOptions_1));
            /**
             * Set the selected options to the default value if there are no
             * other selected options, or there is a value that's controlling
             * the component
             */
            if (selectedOptions.length === 0 || configuration.value) {
                setSelectedOptions(initiallySelectedOptions_1);
            }
        }
    }, [configuration.defaultValue, configuration.value]);
    react_1.useEffect(function () {
        if (configuration.autoFocus) {
            searchableInputEl === null || searchableInputEl === void 0 ? void 0 : searchableInputEl.focus();
        }
    }, [searchableInputEl]);
    react_1.useEffect(function () {
        if (scrollIntoView && highlightedEl && highlightedEl.parentElement) {
            var parentRect = highlightedEl.parentElement.getBoundingClientRect();
            var highlightedRect = highlightedEl.getBoundingClientRect();
            if (highlightedRect.bottom > parentRect.bottom) {
                highlightedEl.scrollIntoView(false);
            }
            else if (highlightedRect.top < parentRect.top) {
                highlightedEl.scrollIntoView(true);
            }
        }
        setScrollIntoView(false);
    }, [highlightedEl]);
    // STATE MANAGEMENT
    var inputValue = react_1.useMemo(function () {
        var _a;
        return selectedOptions
            .map(function (option) { return option.value; })
            .join((_a = configuration.valueDelimiter) !== null && _a !== void 0 ? _a : ",");
    }, [selectedOptions]);
    var isAllSelected = react_1.useMemo(function () {
        return flattenedOptions.every(function (option) { return selectedOptions.includes(option); });
    }, [flattenedOptions, selectedOptions]);
    var getAndSetOptionsDebounced = react_1.useCallback(debounce_1.default(function (query) {
        setSearchQuery(query);
        var asyncFn = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!configuration.getOptions) return [3 /*break*/, 2];
                        setIsSearching(true);
                        return [4 /*yield*/, configuration.getOptions(query)];
                    case 1:
                        results = _a.sent();
                        setOptions(results);
                        setIsSearching(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        asyncFn();
    }, 200), [configuration.getOptions]);
    var open = function () {
        setIsOpen(true);
        searchableInputEl === null || searchableInputEl === void 0 ? void 0 : searchableInputEl.focus();
        // If there are no initial options supplied, and there is a function
        // to get them, then try to get options
        if (!configuration.initialOptions && !options.length) {
            getAndSetOptionsDebounced(searchQuery);
        }
    };
    var close = function () {
        setIsOpen(false);
        // If search isn't inline, then reset it
        if (configuration.searchable && !configuration.inlineSearch) {
            setSearchQuery("");
        }
    };
    var highlightNextOption = function (direction) {
        var options = flattenedOptions;
        if (!highlightedOption && options.length) {
            if (direction === "ArrowUp") {
                setHighlightedOption(options[options.length - 1]);
            }
            else {
                setHighlightedOption(options[0]);
            }
        }
        else {
            var currentlyHighlightedIndex = options.findIndex(function (option) { return option === highlightedOption; });
            var indexToHighlight = 0;
            if (direction === "ArrowUp") {
                indexToHighlight = currentlyHighlightedIndex - 1;
                if (indexToHighlight < 0) {
                    // First item was highlighted, roll over to bottom
                    indexToHighlight = options.length - 1;
                }
            }
            else {
                indexToHighlight = currentlyHighlightedIndex + 1;
                if (indexToHighlight === options.length) {
                    // Last item highlighted, roll over to top
                    indexToHighlight = 0;
                }
            }
            setHighlightedOption(options[indexToHighlight]);
            setScrollIntoView(true);
        }
    };
    // EVENT HANDLING
    var onKeyDown = function (e) {
        switch (e.key) {
            case "ArrowDown":
            case "ArrowUp":
                if (!isOpen) {
                    open();
                }
                else {
                    /**
                     * preventDefault stops the cursor from moving to the start/
                     * end of the text box when using the arrow keys.
                     */
                    e.preventDefault();
                    highlightNextOption(e.key);
                }
                break;
            case " ": // The space key
                /**
                 * If there is a search box, space shouldn't select the
                 * highlighted option as the user may just want to add a space
                 * to the search query.
                 */
                if (configuration.searchable || configuration.inlineSearch) {
                    if (!isOpen) {
                        open();
                    }
                    // Don't fall through (skips selection behaviour)
                    break;
                    /**
                     * If the space key is pressed and there is no search box,
                     * then fall through to "Enter" behaviour 👇
                     */
                }
            case "Enter":
                if (!isOpen) {
                    open();
                }
                else if (highlightedOption) {
                    onSelect(highlightedOption);
                    e.preventDefault();
                }
                break;
            case "Backspace":
                var lastItem = selectedOptions[selectedOptions.length - 1];
                var queryIsEmpty = searchQuery.length === 0;
                if (lastItem && queryIsEmpty) {
                    onSelect(lastItem);
                }
                break;
            default:
                setHighlightedOption(undefined);
        }
    };
    /**
     * Trigger passed down `onChange`. If `value` is controlled, this should
     * ideally change `value` in your implementation so the selected options
     * are updated.
     */
    var callOnChange = function (newSelected) {
        if (configuration.onChange) {
            var values = newSelected.map(function (selected) { return selected.value; });
            if (configuration.multiple) {
                configuration.onChange(values, newSelected);
            }
            else {
                configuration.onChange(values[0], newSelected[0]);
            }
        }
    };
    var onSelect = function (option) {
        // Don't select or deselect if the option is disabled
        if (option.disabled) {
            return;
        }
        var optionIsSelected = selectedOptions.includes(option);
        var newSelected;
        if (optionIsSelected && configuration.multiple) {
            /**
             * In multi-select mode, so deselect the value that was clicked if
             * it's already selected.
             */
            newSelected = selectedOptions.filter(function (selectedOption) { return selectedOption !== option; });
        }
        else {
            if (configuration.multiple) {
                newSelected = __spreadArrays(selectedOptions, [option]);
            }
            else {
                newSelected = [option];
                close();
            }
            /**
             * If inline search is enabled, clear the value.
             *
             * Otherwise, keep the existing search for queries made inside the
             * dropdown. (more like GitLab multi-select behaviour)
             */
            if (configuration.inlineSearch) {
                setSearchQuery("");
                getAndSetOptionsDebounced(configuration.inlineSearch ? "" : searchQuery);
            }
            searchableInputEl === null || searchableInputEl === void 0 ? void 0 : searchableInputEl.focus();
        }
        // If the `value` isn't controlled, then set internal state.
        if (configuration.value === undefined) {
            setSelectedOptions(newSelected);
        }
        // Call onChange with newly selected options
        callOnChange(newSelected);
        searchableInputEl === null || searchableInputEl === void 0 ? void 0 : searchableInputEl.focus();
    };
    var onSearchChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newQuery;
        return __generator(this, function (_a) {
            newQuery = e.target.value;
            setSearchQuery(newQuery);
            getAndSetOptionsDebounced(newQuery);
            if (!isOpen) {
                open();
            }
            return [2 /*return*/];
        });
    }); };
    var onSelectAll = function () {
        if (isAllSelected) {
            setSelectedOptions([]);
        }
        else {
            setSelectedOptions(flattenedOptions);
        }
    };
    /**
     * Clears the list of selected options while leaving pre-selected, disabled
     * options selected.
     */
    var onClearSelection = function () {
        /**
         * Anything that was pre-selected and disabled wasn't selected by the
         * user, so it should not be cleared.
         *
         * In the future, you may wish to make this configurable.
         */
        var optionsToKeepSelected = flattenedOptions.filter(function (option) { return option.disabled && selectedOptions.includes(option); });
        setSelectedOptions(optionsToKeepSelected);
        // Call onChange with newly selected options
        callOnChange(optionsToKeepSelected);
        // After clicking the clear selection button, refocus the search box
        searchableInputEl === null || searchableInputEl === void 0 ? void 0 : searchableInputEl.focus;
    };
    return {
        open: open,
        close: close,
        isOpen: isOpen,
        isSearching: isSearching,
        searchQuery: searchQuery,
        onSearchChange: onSearchChange,
        highlightedOption: highlightedOption,
        setHighlightedOption: setHighlightedOption,
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        onClearSelection: onClearSelection,
        inputValue: inputValue,
        options: options,
        isAllSelected: isAllSelected,
        flattenedOptions: flattenedOptions,
        onKeyDown: onKeyDown,
        setHighlightedEl: setHighlightedEl,
        setSearchableInputEl: setSearchableInputEl,
    };
};
//# sourceMappingURL=useSelect.js.map